export default function mapExtraItemProperties(extra) {
    const properties = {}
    if (!extra) {
        return properties
    }

    if (extra.source_id != null) {
        properties.item_source_id = extra.source_id
    }
    if (extra.source_type) {
        properties.item_source_system = extra.source_type
    }
    if (extra.duration != null) {
        // seconds -> minutes
        properties.item_duration = Math.round(extra.duration / 60)
    }

    return properties
}
